export default __webpack_public_path__ + "static/media/broLogo.603366fb.svg";